import { Component, ViewChild, ViewContainerRef, ComponentFactoryResolver, OnInit, AfterViewInit, Output, EventEmitter, Input, ChangeDetectorRef } from '@angular/core';
import { NavController, NavParams, Events } from 'ionic-angular';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { ConfigureServiceProvider } from '../../providers/configure-service/configure-service';
import { StoreWrapProvider } from '../../providers/store-wrap/store-wrap';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service';
import { SharePage } from '../share/share';
@Component({
    selector: 'page-master',
    templateUrl: 'master.html',
})
export class MasterPage implements OnInit, AfterViewInit {
    componentname: any;
    appLoader: any;
    page_Show: boolean = true;
    pageClassName: any;
    data: any;
    width: any = 80;
    head_width: boolean = false;
    headerShowHide: boolean = false;
    @Input() getRegUserId: any;
    componentRef: any;
    @Input() sharedData: any;
    @Input() sharePageActive: any;
    @Output() loginSuccess = new EventEmitter();
    @ViewChild('container', {
        read: ViewContainerRef,
        static: false
    }) viewContainerRef: ViewContainerRef;
    broadcastSubs: any;
    constructor(public communicationServ: CommunicationServiceProvider, public configApiService: ConfigApiServiceProvider, public storeWrap: StoreWrapProvider, public configureService: ConfigureServiceProvider, public driveService: DriveServiceProvider, public navCtrl: NavController, private cdr: ChangeDetectorRef, public navParams: NavParams, private resolver: ComponentFactoryResolver, public event: Events) {
        this.hide_Page();

        this.initDriveEvents()
    }

    initDriveEvents() {
        this.broadcastSubs = this.communicationServ.getInstance()
            .subscribe((data: any) => {
                if (data.src === "main") {
                    if (data.event === 'headerShow') {
                        this.headerShowHide = data['data'];
                    }
                }
            });
    }
    ngOnInit() {
        this.getAppsList();
    }

    ngAfterViewInit() {
        this.driveService.openDrive(null, () => {
            let component: any;
            this.headerShowHide = true;
            if (this.sharedData) {
                this.loadShareDate()
            } else {
                this.driveService.broadcastInfo({ src: 'main', event: 'loadPageComponent', page: 'Drive', status: true });
            }
            this.cdr.detectChanges();
            this.driveService.broadcastInfo({ src: 'loginPage', event: 'passRegUserId', data: this.getRegUserId });
        }, 'share');
    }

    getAppsList() {
        let appIndex;
        const NO_INDEX = -1;
        let app_code = this.configApiService.currentDriveApp.app_code
        this.configApiService.getApplist((appList) => {
            this.driveService.listUsersAssignedToEpc();
            this.driveService.driveApps = appList;
            appIndex = appList.findIndex(element => element.app_code == app_code);
            if (appIndex != NO_INDEX) {
                this.driveService.current_app_name = appList[appIndex]['app_name']
            }
        })
    }


    /******
     * LOAD SHARE PAGE
     * ******* */
    loadShareDate() {
        let component: any;
        if (this.sharedData.ShareType == "Folder") {
            this.loadShareTypeFolder(component)
        } else {
            if (this.sharedData['ReceiverEmail'] && this.sharedData['sharedInfo'].accessType == 'private') {
                component = SharePage;
                this.loadComponent(component);
            }
        }
    }

    /**********
     * LOAD SHARE FOLDER DATA
     * ************ */
    loadShareTypeFolder(component) {
        component = SharePage;
        this.driveService.getShareRootFolders(this.sharedData['sharedInfo'].sharedFolder, ((rootfolder) => {
            if (rootfolder.folder_id == -1) {
                rootfolder.folder_id = 0;
            }
            this.driveService.objRootFolder = rootfolder;
            this.driveService.objCurrentFolder = rootfolder;
            this.templateCheck();
            this.gotoFolder();

            if (rootfolder['folders'].findIndex(element => element['folder_id'] == this.sharedData['sharedInfo'].sharedFolder.folder_id) == -1) {
                this.driveService.shareFolder(this.sharedData['sharedInfo'].sharedFolder, rootfolder, false, ((data) => {
                    delete this.sharedData['sharedInfo'].sharedFolder.folders;
                    if (this.driveService.objCurrentFolder) {
                        this.driveService.objCurrentFolder['folders'].push(this.sharedData['sharedInfo'].sharedFolder);
                        this.driveService.objRootFolder['folders'].push(this.sharedData['sharedInfo'].sharedFolder);
                    }
                    this.loadComponent(component);
                    console.log('posted Successfully');
                }));
            } else if (rootfolder['folders'].findIndex(element => element['folder_id'] == this.sharedData['sharedInfo'].sharedFolder.folder_id) != -1) {
                let folderIndex = rootfolder['folders'].findIndex(element => element['folder_id'] == this.sharedData['sharedInfo'].sharedFolder.folder_id)
                if (rootfolder['folders'][folderIndex]['IsReadOnlyShare'] != undefined && rootfolder['folders'][folderIndex]['IsReadOnlyShare'] != this.sharedData['sharedInfo'].sharedFolder.IsReadOnlyShare) {
                    delete this.sharedData['sharedInfo'].sharedFolder.folders;
                    this.driveService.shareFolder(this.sharedData['sharedInfo'].sharedFolder, rootfolder, false, ((data) => {
                        if (this.driveService.objCurrentFolder) {
                            this.driveService.objCurrentFolder['folders'][folderIndex] = this.sharedData['sharedInfo'].sharedFolder;
                        } else {
                            this.driveService.objCurrentFolder = this.driveService.objRootFolder;
                            this.driveService.objCurrentFolder['folders'][folderIndex] = this.sharedData['sharedInfo'].sharedFolder;
                        }
                        this.driveService.objRootFolder['folders'][folderIndex] = this.sharedData['sharedInfo'].sharedFolder;
                        this.loadComponent(component);
                        console.log('posted updated Successfully');
                    }));
                } else {
                    this.loadComponent(component);
                }
            } else {
                this.loadComponent(component);
            }
        }));
    }

    loadComponent(component) {
        if (component) {
            const componentFactory = this.resolver.resolveComponentFactory(component);
            this.componentRef = this.viewContainerRef.createComponent(componentFactory);
            this.componentRef.instance.sharedData = this.sharedData;
        }
    }

    templateCheck() {
        if (this.sharedData.sharedInfo.sharedFolder.template.length > 1) {
            for (var i = 0; i < this.sharedData.sharedInfo.sharedFolder.template.length; i++) {
                if (!this.storeWrap.storeTemplates[this.sharedData.sharedInfo.sharedFolder.template[i].id]) {
                    let _tempData = Object.assign({}, this.configApiService.driveApi.pullFolderTemplate.params, this.sharedData.sharedInfo.pullFolderTemplate, {
                        "ScreenName": this.sharedData.sharedInfo.sharedFolder.template[i].id
                    })
                    this.configApiService.pullRequest(_tempData, (template => {
                        console.log(this.storeWrap.storeTemplates);
                        this.storeWrap.storeTemplates[eval('(' + template[0].PluginData + ')')['id']] = eval('(' + template[0].PluginData + ')');
                    }))
                }
            }
        } else if (this.sharedData.sharedInfo.sharedFolder.template.length == 1) {
            if (!this.storeWrap.storeTemplates[this.sharedData.sharedInfo.sharedFolder.template[0].id]) {
                let _tempData = Object.assign({}, this.configApiService.driveApi.pullFolderTemplate.params, this.sharedData.sharedInfo.pullFolderTemplate, {
                    "ScreenName": this.sharedData.sharedInfo.sharedFolder.template[0].id
                })
                this.configApiService.pullRequest(_tempData, (template => {
                    console.log(this.storeWrap.storeTemplates);
                    // this.storeWrap.storeTemplates.push(template);
                    this.storeWrap.storeTemplates[eval('(' + template[0].PluginData + ')')['id']] = eval('(' + template[0].PluginData + ')')
                }))
            }
        }
    }

    gotoFolder() {
        if (this.sharedData.sharedInfo.sharedFolder.folders.length > 1) {
            for (var i = 0; i < this.sharedData.sharedInfo.sharedFolder.folders.length; i++) {
                for (var j = 0; j < this.sharedData.sharedInfo.sharedFolder.folders[i].template.length; j++) {
                    if (!this.storeWrap.storeTemplates[this.sharedData.sharedInfo.sharedFolder.folders[i].template[j].id]) {
                        let _tempData = Object.assign({}, this.configApiService.driveApi.pullFolderTemplate.params, this.sharedData.sharedInfo.pullFolderTemplate, {
                            "ScreenName": this.sharedData.sharedInfo.sharedFolder.folders[i].template[j].id
                        })
                        this.configApiService.pullRequest(_tempData, (template => {
                            console.log(this.storeWrap.storeTemplates);
                            this.storeWrap.storeTemplates[eval('(' + template[0].PluginData + ')')['id']] = eval('(' + template[0].PluginData + ')');
                        }))
                    }
                }
            }

        }
    }

    pageClass($event) {
        this.pageClassName = $event;
        const componentFactory = this.resolver.resolveComponentFactory(this.pageClassName['component']);
        this.viewContainerRef.clear();
        this.componentRef = this.viewContainerRef.createComponent(componentFactory);
        this.componentRef.instance.params = $event;
        this.appLoader = $event;
    }

    hide_Page() {
        this.broadcastSubs = this.communicationServ.getInstance()
            .subscribe((data: any) => {
                if (data.src === "header") {
                    if (data.event === 'Hidepage') {
                        let status = data['data'];
                        if (status == true) {
                            this.page_Show = false;
                            this.head_width = true;
                        } else {
                            this.page_Show = true;
                            this.head_width = false;
                        }
                        setTimeout(() => {
                            this.driveService.broadcastInfo({ src: 'main', event: 'activepage', status: this.page_Show });
                        }, 5);

                    }
                }
            });
    }


    openLeftSideNav() {
        this.page_Show = !this.page_Show;
        if (this.page_Show) {
            this.driveService.LeftSideNavBar('')
        } else {
            this.driveService.LeftSideNavBar('leftSideNav')
        }
    }

    ngOnDestroy() {
        this.broadcastSubs.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/pages/master/master.ts